import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class InvoiceServiceClass {
    create(data) {
        return BaseService.post(`${APIPath.invoiceCreate}`, data)
    }

    getCompletedAudits(queryParams) {
        return BaseService.post(`${APIPath.getCompletedAudits}`, queryParams)
    }

    searchInvoices(body) {
        const pageNumber = body?.PageNumber ?? 1
        const pageSize = body?.PageSize ?? 50
        const url = `${APIPath.invoiceSearch}?pageNumber=${pageNumber}&pageSize=${pageSize}`
        const payload = { ...body }
        delete payload.PageNumber
        delete payload.PageSize
        return BaseService.post(url, payload)
    }

    // GET /company/Invoice/{invoiceId}
    getById(invoiceId) {
        return BaseService.get(`${APIPath.invoiceGetById}${invoiceId}`)
    }

    // POST /company/Invoice/Update
    updateHeader(header, lines = []) {
        const defaultInvoice = {
            InvoiceId: 0,
            CompanyId: 0,
            CustomerId: 0,
            CustomerName: '',
            CustomerEmail: '',
            BillingAddress: '',
            InvoiceNumber: '',
            InvoiceNumberInt: 0,
            InvoiceNumberDisplay: '',
            InvoiceType: 0,
            InvoiceStatus: 0,
            SourceType: 0,
            InvoiceDate: '',
            DueDate: '',
            CurrencyCode: '',
            TaxRatePercent: 0,
            SubtotalAmount: 0,
            DiscountAmount: 0,
            TaxAmount: 0,
            ShippingAmount: 0,
            TotalAmount: 0,
            AmountPaid: 0,
            AmountOutstanding: 0,
            PaymentTermsDays: 0,
            ReferenceNumber: '',
            NotesInternal: '',
            NotesPublic: '',
            TermsAndConditions: '',
            LastEmailSentOn: '',
            LastEmailSentTo: '',
            IsDeleted: false,
            CreatedByUserId: 0,
            CreatedOn: new Date().toISOString(),
            ModifiedByUserId: 0,
            ModifiedOn: new Date().toISOString(),
            Lines: [],
            Payments: [],
            CompanyName: '',
            AuditLinks: [],
            LinkedAuditIds: [],
            AuditReferences: [],
        }

        // Merge with default values and ensure no null values
        const payload = {
            ...defaultInvoice,
            ...header,
            Lines: lines.map(line => ({
                InvoiceLineId: line.InvoiceLineId || 0,
                InvoiceId: line.InvoiceId || 0,
                LineNumber: line.LineNumber || 0,
                LineType: line.LineType || 0,
                Description: line.Description || '',
                Quantity: line.Quantity || 0,
                AuditReferences: line.AuditReferences || [], // Fix ESLint error
                LineSubtotal: line.LineSubtotal || 0,
                DiscountAmount: line.DiscountAmount || 0,
                TaxableAmount: line.TaxableAmount || 0,
                TaxAmount: line.TaxAmount || 0,
                LineTotal: line.LineTotal || 0,
                AuditId: line.AuditId || 0,
                TemplateId: line.TemplateId || 0,
                LocationId: line.LocationId || 0,
                TaxRateId: line.TaxRateId || 0,
                TaxRatePercent: line.TaxRatePercent || 0,
                IsDeleted: line.IsDeleted || false,
                CreatedByUserId: line.CreatedByUserId || 0,
                CreatedOn: line.CreatedOn || new Date().toISOString(),
                ModifiedByUserId: line.ModifiedByUserId || 0,
                ModifiedOn: line.ModifiedOn || new Date().toISOString(),
                UnitPrice: line.UnitPrice || 0,
            })),
        }

        // Ensure dates are properly formatted
        const dateFields = [
            'InvoiceDate',
            'DueDate',
            'LastEmailSentOn',
            'CreatedOn',
            'ModifiedOn',
        ]
        dateFields.forEach(field => {
            if (payload[field] && payload[field] instanceof Date) {
                payload[field] = payload[field].toISOString()
            }
        })

        return BaseService.post(APIPath.invoiceUpdateHeader, payload)
    }

    // POST /company/Invoice/{invoiceId}/Lines/Update
    updateLines(invoiceId, lines = []) {
        return BaseService.post(
            `${APIPath.invoiceUpdateLines}${invoiceId}/Lines/Update`,
            lines,
        )
    }

    // POST /company/Invoice/{invoiceId}/Delete (soft delete)
    softDelete(invoiceId) {
        return BaseService.post(
            `${APIPath.invoiceSoftDelete}${invoiceId}/Delete`,
            {},
        )
    }

    // GET /company/Invoice/Currencies
    getCurrencies() {
        return BaseService.get(`${APIPath.server}company/Invoice/Currencies`)
    }

    // POST Company/Invoice/SendEmail
    // Uses APIPath.server as base to avoid modifying API constants file
    sendEmail(body) {
        return BaseService.post(
            `${APIPath.server}Company/Invoice/SendEmail`,
            body,
        )
    }

    // GET /company/Invoice/{invoiceId}/Pdf as Blob
    getPdf(invoiceId) {
        return BaseService.get(
            `${APIPath.server}company/Invoice/${invoiceId}/Pdf`,
        )
    }
}

const InvoiceService = new InvoiceServiceClass()
Object.freeze(InvoiceService)
export { InvoiceService }
